import {
  CREATE_COMPONENT_COMPONENT_SELECTED,
  CREATE_DUPLICATE_COMPONENT,
  GET_EXISTING_COMPONENTS_FULLFILLED,
  OPEN_COMPONENT_FOR_EDITING
} from 'app/CanvasComponent/const';
import { COMPONENT_SAVE_FULFILLED, COMPONENT_MODIFIED } from 'app/EditorPane/const';
import {
  ADD_COMPONENT_TO_PAGE,
  CHANGE_PAGE_PROPERTY,
  CREATE_UNSAVED_PAGE,
  DUPLICATE_PAGE,
  GET_PAGE_REQUEST,
  GET_PAGE_SUCCESS,
  PAGE_COMPONENTS_LIST_CHANGED,
  REMOVE_ACTIVE_PAGE,
  REMOVE_COMPONENT_FROM_PAGE,
  REPLACE_COMPONENT_ON_THE_PAGE,
  SAVE_PAGE_SUCCESS
} from 'app/Page/const';
import {
  HIDE_UNSAVED_CHANGES_CONFIRMATION,
  SHOW_UNSAVED_CHANGES_CONFIRMATION
} from 'app/UnsavedChangesConfirmationModal/const';

// dse contracts
// TODO: Not able to import DSE contracts, find out why.
import dseCarouselContract from '@dse/canvas-contracts/carouselContract';
import dseCarouselImageContract from '@dse/canvas-contracts/carouselImageContract';

// local contracts without a true nui component
import experimentContract from 'lib/contract/experiment';

// TODO remove once pdp drops support
import {
  EDIT_STATUS_MODIFIED,
  EDIT_STATUS_NEW,
  EDIT_STATUS_NONE,
  EDIT_STATUS_SAVED,
  MODE_SWITCHED,
  PAGE_TEMPLATES,
  COMPONENT_TEMPLATE,
  SET_FAILED_VALIDATIONS,
  GET_CONFIG_SUCCESS,
  GET_AUDIENCE_TAGS_SUCCESS
} from './const';

export const localContracts = [
  dseCarouselContract,
  dseCarouselImageContract,
  experimentContract
];

export const defaultState = {
  applicationMode: PAGE_TEMPLATES,
  editStatus: EDIT_STATUS_NONE,
  showUnsavedChangesConfirmation: false,
  postSaveActions: [],
  postDiscardActions: [],
  failedValidations: {}
};

export const variationMapper = contracts =>
  contracts.reduce(
    (acc, { name, displayName = name }) => ({ ...acc, [displayName]: displayName }),
    {}
  );

export const contractMapper = contracts =>
  contracts.reduce(
    (acc, { name, displayName = name }, ind, arr) => ({ ...acc, [displayName]: arr[ind] }),
    {}
  );

/**
 * reducer for app state
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
const reducer = function appReducer(state = defaultState, action = {}) {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case MODE_SWITCHED:
      return {
        ...state,
        applicationMode: action.applicationMode
      };
    case HIDE_UNSAVED_CHANGES_CONFIRMATION:
      return {
        ...state,
        showUnsavedChangesConfirmation: defaultState.showUnsavedChangesConfirmation,
        postSaveActions: defaultState.postSaveActions,
        postDiscardActions: defaultState.postDiscardActions
      };
    case SHOW_UNSAVED_CHANGES_CONFIRMATION:
      return {
        ...state,
        showUnsavedChangesConfirmation: true,
        postSaveActions: action.postSaveActions,
        postDiscardActions: action.postDiscardActions
      };
    case REMOVE_ACTIVE_PAGE:
      return {
        ...state,
        editStatus: EDIT_STATUS_NONE
      };
    case CREATE_DUPLICATE_COMPONENT:
    case CREATE_COMPONENT_COMPONENT_SELECTED:
      return {
        ...state,
        applicationMode: COMPONENT_TEMPLATE,
        editStatus: EDIT_STATUS_NEW
      };
    case GET_CONFIG_SUCCESS: {
      const contractsToMap = action.config
        .concat(localContracts)
        .filter(Boolean)
        .reduce((acc, cur) => acc.concat(cur), []);

      return {
        ...state,
        contractMap: contractMapper(contractsToMap),

        // TODO deprecate variation map because we no longer need schema -> variation mapping
        variationMap: variationMapper(contractsToMap)
      };
    }
    case GET_AUDIENCE_TAGS_SUCCESS: {
      return {
        ...state,
        audienceTags: action.audienceTags.map(tag => `${tag.code} | ${tag.name}`)
      };
    }
    case GET_EXISTING_COMPONENTS_FULLFILLED:
    case COMPONENT_SAVE_FULFILLED:
      return {
        ...state,
        applicationMode: COMPONENT_TEMPLATE,
        editStatus: EDIT_STATUS_SAVED
      };
    case OPEN_COMPONENT_FOR_EDITING:
      return {
        ...state,
        applicationMode: COMPONENT_TEMPLATE
      };
    case DUPLICATE_PAGE:
    case CREATE_UNSAVED_PAGE:
      return {
        ...state,
        applicationMode: PAGE_TEMPLATES,
        editStatus: EDIT_STATUS_NEW
      };
    case GET_PAGE_SUCCESS:
    case GET_PAGE_REQUEST:
    case SAVE_PAGE_SUCCESS:
      return {
        ...state,
        applicationMode: PAGE_TEMPLATES,
        editStatus: EDIT_STATUS_SAVED
      };
    case ADD_COMPONENT_TO_PAGE:
    case REPLACE_COMPONENT_ON_THE_PAGE:
    case REMOVE_COMPONENT_FROM_PAGE:
    case PAGE_COMPONENTS_LIST_CHANGED:
    case CHANGE_PAGE_PROPERTY:
    case COMPONENT_MODIFIED:
      return {
        ...state,
        editStatus:
          state.editStatus === EDIT_STATUS_NEW ? EDIT_STATUS_NEW : EDIT_STATUS_MODIFIED
      };
    case SET_FAILED_VALIDATIONS:
      return {
        ...state,
        failedValidations: action.failedValidations
      };
    default:
      return state;
  }
};

export default reducer;
